'use client';

import NotFound from '@/components/NotFound';

const NotFoundPage = () => {
  console.warn('User navigated to a not found page.');
  return <NotFound />;
};

export default NotFoundPage;
